import { useRouter } from "next/router"
import { BlitzPage, Routes } from "@blitzjs/next"
import { SignupForm } from "app/auth/components/SignupForm"
import Onboarding from "app/core/layouts/OnboardingV2"
import tw from "tailwind-styled-components"
import { CardBlur } from "app/auth/components/LoginForm"
import { ColorBlur } from "app/splash/components/ColorBlur"
import Link from "next/link"
import { Title } from "./forgot-password"
import useUtmParams from "app/core/hooks/useUTMParams"

const Container = tw.div`

`

const SignupPage: BlitzPage = () => {
  const router = useRouter()
  const { utmParams } = useUtmParams()

  return (
    <CardBlur>
      <ColorBlur fixed={true} opacity={0.05}></ColorBlur>
      <Container>
        <Title>Sign up</Title>
        <div className="mb-6">
          <span className="!text-sm">
            <Link passHref={true} href={Routes.LoginPage()}>
              <span className="opacity-80">{`Have an account? `}</span>
              <span className="text-brand-primary font-medium">{`Log in →`}</span>
            </Link>
          </span>
        </div>
        <SignupForm
          onSuccess={({ user }) => {
            const next = router.query.next ? decodeURIComponent(router.query.next as string) : null
            if (next) {
              return router.push(next)
            }
            router.push(
              Routes.OnboardingNewApplicationPage({
                ...utmParams,
                platform: "ios",
              })
            )
          }}
        />
      </Container>
    </CardBlur>
  )
}

SignupPage.redirectAuthenticatedTo = "/"
SignupPage.getLayout = (page) => (
  <Onboarding title="Sign Up | Superwall" includeMenu>
    {page}
  </Onboarding>
)

export default SignupPage
